import React, { useEffect, useState } from 'react'
import { router } from '@inertiajs/react'
import { Progress } from '@/components/ui/progress'

export function NavigationProgress() {
  const [progress, setProgress] = useState(0)
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const removeStartListener = router.on('start', () => {
      setProgress(0)
      setVisible(true)
    })

    const removeProgressListener = router.on('progress', (event) => {
      if (event.detail.progress?.percentage) {
        setProgress(event.detail.progress.percentage)
      }
    })

    const removeFinishListener = router.on('finish', () => {
      setProgress(100)
      setTimeout(() => {
        setVisible(false)
        setProgress(0)
      }, 200)
    })

    return () => {
      removeStartListener()
      removeProgressListener()
      removeFinishListener()
    }
  }, [])

  if (!visible) return null

  return (
    <Progress
      value={progress}
      className="fixed top-0 left-0 right-0 z-50 h-1 rounded-none"
    />
  )
}
